import { abilitiesPlugin } from '@casl/vue';
import featuresPlugin from '@/common/utils/featuresPlugin';
import notificationsPlugin from '@/common/utils/notifications/notificationsPlugin';
import Vue from 'vue';
import { Pinia } from 'pinia';
import keyboardController from '@/common/utils/keyboardController';

export default function initPlugins(pinia: Pinia) {
  Vue.use(abilitiesPlugin);
  Vue.use(featuresPlugin, pinia);
  Vue.use(notificationsPlugin);
  Vue.use(keyboardController);
}
